import { cn } from "@lib/utils"
import { Text } from "@medusajs/ui"

type LineItemOptionsProps = {
  title: string | number
  label?: string
  "data-testid"?: string
  "data-value"?: unknown
  className?: string
  priceClassName?: string
}

const LineItemOptions = ({
  title,
  label,
  "data-testid": dataTestid,
  "data-value": dataValue,
  className,
  priceClassName,
}: LineItemOptionsProps) => {
  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className={`inline-block text-xs text-ui-fg-subtle w-full overflow-hidden text-ellipsis capitalize ${
        className || ""
      }`}
    >
      {label && label + ": "}
      <span className={cn("text-slate-900", priceClassName)}>{title}</span>
    </Text>
  )
}

export default LineItemOptions
